import type { PostRemovalStatus } from "./useCompetitorLinkRemovalDetail";

export function removalStatusColor(status: PostRemovalStatus): "default" | "success" | "error" | "warning" {
  let removalStatusColorOutcome: "default" | "success" | "error" | "warning";
  if (status === "removed") {
    removalStatusColorOutcome = "success";
  } else {
    if (status === "failed") {
      removalStatusColorOutcome = "error";
    } else {
      if (status === "skipped") {
        removalStatusColorOutcome = "warning";
      } else {
        removalStatusColorOutcome = "default";
      }
    }
  }
  return removalStatusColorOutcome;
}
